import { FC } from 'react';

import {
  NavigationContainer,
  NavigationItem,
  NavigationItemWrapper,
  NavigationDivider,
  NavigationText,
  NavigationIcon,
} from './ApplicationNavigation.styles';

import { ArrowUpward } from '@mui/icons-material';

interface NavigationItemData {
  id: string;
  label: string;
}

const navigationItems: NavigationItemData[] = [
  { id: 'key-challenges', label: 'Key Challenges' },
  { id: 'key-capabilities', label: 'Key Capabilities' },
  { id: 'why-choose-us', label: 'Why Teams Choose AiLS 2.0' },
];

const scrollToSection = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    const headerOffset = -30;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};

export const ApplicationNavigation: FC = () => {
  return (
    <NavigationContainer>
      {navigationItems.map((item, index) => (
        <NavigationItemWrapper key={item.id}>
          {index === 0 && <NavigationDivider />}
          {index > 0 && <NavigationDivider />}
          <NavigationItem onClick={() => scrollToSection(item.id)}>
            <NavigationText>{item.label}</NavigationText>
            <NavigationIcon>
              <ArrowUpward />
            </NavigationIcon>
          </NavigationItem>
          {index === navigationItems.length - 1 && <NavigationDivider />}
        </NavigationItemWrapper>
      ))}
    </NavigationContainer>
  );
};
